import React from "react";
import { StyledButton, Text } from "./styles";

export const Button = ({ text, link }) => (
  <StyledButton href={link} target="_blank">
    <Text>{text}</Text>
  </StyledButton>
);
